import React, { Fragment, useContext } from 'react';
import { Row, Col, Label, Input } from 'reactstrap';
import FindTryout from './FindTryout';
import DatePicker from 'react-datepicker';
import LearningContext from '../../../_helper/Leatning';

const TryoutFilter = () => {
  const { isOpen, setIsOpen } = useContext(LearningContext);
  const onClickeHandel = () => {
    setIsOpen(!isOpen);
  };
  return (
    <Fragment>
      <Col xl="3 xl-20">
        <div className="job-sidebar md-sidebar"><a className="btn btn-primary md-sidebar-toggle" href="#javascript" onClick={onClickeHandel}>Tryout Filter</a>
          <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${isOpen ? 'open' : ''}`}>
            <div className="default-according" id="accordionoc">
              <Row>
                <FindTryout />
              </Row>
            </div>
          </div>
        </div>
      </Col>
    </Fragment>
  );
};

export default TryoutFilter;